import React from 'react';
import Skeleton from 'react-loading-skeleton';
import './style.less';

export const SpotlightActivityItemSkeleton: React.FC = () => {
  return (
    <div className="SpotlightActivityItemSkeleton">
      <div className="SpotlightActivityItemSkeleton__icon">
        <Skeleton circle baseColor="#F6F7F9" width={32} height={32} />
      </div>
      <div className="SpotlightActivityItemSkeleton__content">
        <div className="SpotlightActivityItemSkeleton__summary">
          <Skeleton baseColor="#F6F7F9" height={'100%'} width={200} />
          <Skeleton baseColor="#F6F7F9" height={'100%'} width={20} />
        </div>

        <Skeleton baseColor="#F6F7F9" width={'100%'} height={125} borderRadius={8} />
      </div>
    </div>
  );
};
